import { Component, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DOCUMENT } from '@angular/common';
import { timer } from 'rxjs';

import { ModalSizeSettings } from '../../modals/modal-settings.model';
import { PaymentOptionsModal } from '../../modals/payment-options.modal';
import { MessageService } from '../../services/message.service';
import { CitationService } from '../../services/citation.service';
import { ClientService } from '../../services/client.service';
import { ClientStyleService } from '../../services/client-style.service';
import { InvoiceService } from '../../services/invoice.service';
import { PayableCitationModel } from '../../models/payable-citation.model';
import { InvoiceModel, OrderModel, OrderItemModel } from 'src/app/models/invoice.model';
import { PaymentMethodEnum, PaymentTypeEnum, SolutionTypeEnum } from '../../models/lookups.enum';
import { BoolStringPipe } from '../../pipes/boolstring.pipe';
import { BaseComponent } from '../base/base.component';

import * as moment from 'moment';

export interface CitationResult {
	citationKey: string;
	citationNumber: string;
	description: string;
	issuedDate: string;
	amount: string;
}

@Component({
	selector: 'app-citation-payments',
	templateUrl: './citation-payments.component.html',
	styleUrls: ['./citation-payments.component.css']
})

export class CitationPaymentsComponent extends BaseComponent implements OnInit {

	citationSearchTableColumns: string[] = ['citationKey', 'citation', 'description', 'issued', 'amountDue'];
	selectedCitationTableColumns: string[] = ['citation', 'description', 'amount'];
	citationInvoiceTableColumns: string[] = ['citation', 'description', 'amount'];

	public selectedEntityKey: string;
	public selectedOrderKey: string;
	public activeCurrency: string = 'USD';
	public formSubmitMethod: string = 'POST';
	public searchPlate: string;
	public clientName: string;
	public retryOrderKey: string;
	public orderRefNumber: string;
	public searchCitation: string;
	public selectedCitationKey: string = '';
	public searchResults: PayableCitationModel[];
	public selectedItems: any[] = [];
	public totalAmountDue: number = 0;
	public totalTaxesDue: number = 0;
	public totalAmountDueInclTax: number = 0;
	public invoiceMessages: string;
	public activeTaxRates: any[] = [];
	public processing: boolean = false;
	public showingInvoice: boolean = false;
	public showingReceipt: boolean = false;
	public showingSearchResults: boolean = true;
	public payModuleTitle: string = 'Select Payment Method';
	public appealsUrl: string;
	public paidDate: Date;
	public isManualEntry: boolean;
	public isProcessing: boolean = false;
	public manualPayment: any = {};
	public useBatch: boolean;
	public hasConfirmation: boolean = false;
	public manualPaymentId: number;
	public manualPaymentType: string;
	public canAppeal: boolean = false;
	public allSelected: boolean = false;
	public cardProcessorAvailable: boolean = null;
	public cardProcessorLoading: boolean = null;
	public adminPaySupport: boolean = false;
	public clientPaymentProfile: any = {};
	public payTypes: PaymentTypeEnum = new PaymentTypeEnum();
	public payMethods: PaymentMethodEnum = new PaymentMethodEnum();
	public solutionTypeEnum: SolutionTypeEnum = new SolutionTypeEnum();
	public activeInvoice: InvoiceModel = new InvoiceModel();
	public activeOrder: OrderModel = new OrderModel();
	public orderItems: OrderItemModel[] = [];
	private modalSize: ModalSizeSettings = new ModalSizeSettings();

	//public citationList: PayableCitationModel[];
	public citationsForPayment: PayableCitationModel[] = [];
	public citationTotal: number = 0;


	constructor(private route: ActivatedRoute, public router: Router, public _messageService: MessageService, public _citationService: CitationService, public _clientService: ClientService, public _clientStyleService: ClientStyleService, public _invoiceService: InvoiceService, public dialog: MatDialog, private _snackBar: MatSnackBar)
	{
		super(router, route, _messageService, _clientService, _clientStyleService);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.route.paramMap.subscribe(params => {
			this.selectedOrderKey = params.get('key');
			this.orderRefNumber = params.get('invNum');
			this.retryOrderKey = params.get('retryKey');

			let searchPlate = params.get('searchPlate')
			if (searchPlate !== undefined && searchPlate != null && searchPlate.trim() != '') {
				this.searchPlate = searchPlate.trim().toUpperCase();
			} else {
				this.searchPlate = '';
			}

			let searchCitation = params.get('searchCitation')
			if (searchCitation !== undefined && searchCitation != null && searchCitation.trim() != '') {
				this.searchCitation = searchCitation.trim().toUpperCase();
			} else {
				this.searchCitation = '';
			}

			if (params.get('searchKey') != null) {
				this.selectedCitationKey = params.get('searchKey');
			}
			this.useBatch = Boolean(params.get('batch'));
		});

		var tokenData = localStorage.getItem('token');
		if (tokenData != null) {
			var token = JSON.parse(tokenData);
			if (token.owner !== undefined && token.owner != null) {
				this.activeInvoice.email = token.owner.email;
			}
		}

		Promise.resolve(null).then(() => {
			if (this.selectedOrderKey !== undefined && this.selectedOrderKey != null && this.selectedOrderKey.trim() != '') {
				this.getSelectedOrder();
			} else if(this.retryOrderKey) {
				this.getRetryOrder();
			} else {
				this.getAnOrder();
			}

			if ((this.searchPlate !== undefined && this.searchPlate != null && this.searchPlate.trim() != '') || (this.searchCitation !== undefined && this.searchCitation != null && this.searchCitation.trim() != '') || (this.selectedCitationKey !== undefined && this.selectedCitationKey != null && this.selectedCitationKey.trim() != '')) {
				this.searchCitations();
			}
		});
	}

	public pleaseWait() {
		this._messageService.showAppMessage('Please Wait...', 'We are processing your request.');
	}

	public printPage() {
		this._messageService.clearAppError();
		window.print();
	}

	public refreshPayPage() {
		if(this.selectedOrderKey !== undefined && this.selectedOrderKey != null && this.selectedOrderKey.trim() != '') {
			this.getSelectedOrder();
		}
	}

	public submitForm() {
		this.isProcessing = true;
	}

	public getAnOrder() {
		this._invoiceService.getAnOrder().subscribe((response: any) => {
			this.activeOrder = response;
			this.selectedOrderKey = this.activeOrder.orderKey;
		}, (error: any) => {
			this._messageService.showAppError('Error!', error);
		});
	}

	public getSelectedOrder() {
		this._messageService.isBusy = true;
		this._invoiceService.getStoreOrder(this.selectedOrderKey, this.orderRefNumber).subscribe((response: any) => {
			this.activeOrder = response;
			this.backloadOrderItems();
			if(this.isPending(this.activeOrder.orderStatusId)) {
				this.messageService.isBusy = true;
				var buff = timer(10000).subscribe((response: any) => {
					this.getSelectedOrder();
					buff.unsubscribe();
				});
			} else {
				this.getClientTaxProfile();
				this.getOrderItems();
				this.getClientProcessorProfile();
				this.messageService.isBusy = false;
			}
			this._clientService.loadClientByKey(this.activeOrder.clientKey);
			this._clientStyleService.loadClientBranding(this.activeOrder.clientKey);
		}, (error: any) => {
			this._messageService.showAppError('Error!', error);
		});

		if (this.useBatch === undefined || this.useBatch == null || this.useBatch == false) {
			this.showingReceipt = true;
		}
		this.showingInvoice = true;
		this.showingSearchResults = false;

	}

	public getRetryOrder() {
		this._messageService.isBusy = true;
		this.cardProcessorAvailable = null;
		this.cardProcessorLoading = true;
		this._invoiceService.getRetryOrder(this.retryOrderKey).subscribe((response: any) => {
			this.activeOrder = response;
			this.orderItems = this.activeOrder.orderItems;
			this.backloadOrderItems();
			this.getClientTaxProfile();
			this.getClientProcessorProfile();
			this._messageService.isBusy = false;
		}, (error: any) => {
			this._messageService.showAppError('Error!', error);
		});
		this.showingReceipt = false;
		this.showingInvoice = true;
		this.showingSearchResults = false;
	}

	public searchCitations() {
		this._messageService.isBusy = true;
		var refDate: string = moment().local().format('YYYY-MM-DDTHH:mm:ss');
		this._citationService.searchCitationPayments(this.searchPlate, this.searchCitation, this.selectedCitationKey, refDate).subscribe((results: any) => {
			this.searchResults = results;
			var selectedCitation = this.searchResults[this.searchResults.findIndex((f: any) => { return f.citationKey === this.selectedCitationKey; })];
			if (selectedCitation !== undefined && selectedCitation != null
				&& selectedCitation.statusId != this._citationService.citationStatusEnum.Cancelled
				&& selectedCitation.statusId != this._citationService.citationStatusEnum.Paid
				&& selectedCitation.statusId != this._citationService.citationStatusEnum.Warning
				&& selectedCitation.statusId != this._citationService.citationStatusEnum.NotPayable) 
			{
				this.selectedItems.push(selectedCitation);
			}

			this.getClientTaxProfile();
			this._messageService.isBusy = false;

			if ((this.searchPlate === undefined || this.searchPlate == null || this.searchPlate.trim() == '') && this.searchResults.length > 0 && this.searchResults[0].plate != '') {
				this.searchPlate = this.searchResults[0].plate;
			}

			this.canAppeal = this.searchResults.findIndex((f: any) => { return f.canAppeal == true; }) >= 0;

			if(this.canAppeal) {
				this.citationSearchTableColumns.push('appeals');
				this.getAppealsUrl();
			}
		}, (error: any) => {
			this.searchResults = null;
			this.showResults();
			this._messageService.showAppError('Error!', error);
		});
	}

	public setSelectedCitation(cit: PayableCitationModel) {
		var selectedIndex = this.isSelected(cit.citationKey);
		if (selectedIndex < 0 && cit.statusId != this._citationService.citationStatusEnum.NotPayable) {
			this.selectedItems.push(cit);
		} else {
			this.selectedItems.splice(selectedIndex, 1);
		}

		this.calcTotalAmountDue();
	}

	public selectCitation(cec: any, event: any) {
		if (cec !== undefined && cec != null && cec.citationKey.trim() != '') {
			if (event.shiftKey) {
				var lastCitationFound: number = this.searchResults.findIndex((f: any) => { return f.citationKey == this.selectedEntityKey; });
				var startSelection: number = lastCitationFound;
				var endSelection: number = this.searchResults.findIndex((f: any) => { return f.citationKey == cec.citationKey; });

				if (startSelection > endSelection) {
					var t: number = startSelection;
					startSelection = endSelection;
					endSelection = t;
				} else if (startSelection < 0) {
					startSelection = endSelection;
				}

				for (var i = startSelection; i <= endSelection; i++) {
					if (i != lastCitationFound) {
						var foundIndex = this.getSelectedIndex(this.searchResults[i].citationKey);

						if (foundIndex < 0 && cec.amount > 0 && this.searchResults[i].statusId != this._citationService.citationStatusEnum.NotPayable) {
							this.pushSelectedItem(this.searchResults[i]);
						}
					}
				}
			} else {
				var foundIndex = this.getSelectedIndex(cec.citationKey);
				if (foundIndex < 0 && cec.amount > 0 && cec.statusId != this._citationService.citationStatusEnum.NotPayable) {
					this.pushSelectedItem(cec);
				} else {
					this.selectedItems.splice(foundIndex, 1);
				}
			}
			this.selectedEntityKey = cec.citationKey;
		}
		this.calcTotalAmountDue();
	}

	public getSelectedIndex(key: string) {
		return this.selectedItems.findIndex((f: any) => { return f.citationKey == key.toLowerCase(); });
	}

	public selectAll() {
		for (var i in this.searchResults) {
			var cec = this.searchResults[i];
			var foundIndex = this.getSelectedIndex(cec.citationKey);
			if (this.allSelected) {
				this.selectedItems.splice(foundIndex, 1);
			} else if (foundIndex < 0 && cec.statusId != this._citationService.citationStatusEnum.NotPayable) {
				this.pushSelectedItem(cec);
			}
		}

		this.allSelected = !this.allSelected;
		this.calcTotalAmountDue();
	}

	public trackSearchKey() {
		if (this.selectedItems.length > 0) {
			localStorage.setItem('searchToken', this.selectedItems[0].citationKey);
		} else {
			localStorage.removeItem('searchToken');
		}
	}

	private pushSelectedItem(cec: any) {
		if (cec.amountDue > 0) {
			this.selectedItems.push({ citationKey: cec.citationKey.toLowerCase(), citationNumber: cec.citationNumber, description: cec.description, plate: cec.plate, amountDue: cec.amountDue, entitySourceId: cec.entitySourceId, officerId: cec.officerId, issuedDate: cec.issuedDate });
		}
	}


	public isSelected(citationKey: string) {
		//return this.selectedItems.findIndex((f: any) => { return f.citationKey !== undefined && f.citationKey != null && f.citationKey === citationKey; });
		let item = this.selectedItems.find(c => c.citationKey == citationKey);
		if (item != null) {
			return 1;
		} else {
			return 0;
		}
	}

	public isInAppeals(statusId: number) {
		return statusId == this._citationService.citationStatusEnum.InAppeals;
	}

	public isPayable(statusId: number) {
		return statusId != this._citationService.citationStatusEnum.NotPayable;
	}

	public isComplete(statusId: number) {
		return statusId == this._citationService.citationStatusEnum.Paid || statusId == this._citationService.citationStatusEnum.Cancelled || statusId == this._citationService.citationStatusEnum.Warning;
	}

	private calcTotalAmountDue() {
		var totalAmountDue: number = 0;
		for (var i in this.selectedItems) {
			totalAmountDue += this.selectedItems[i].amountDue;
		}
		this.totalAmountDue = totalAmountDue;
		this.totalTaxesDue = this.applyActiveTaxes(totalAmountDue);
		this.totalAmountDueInclTax = this.totalAmountDue + this.totalTaxesDue;
	}

	public createOrder() {
		this._messageService.clearAppError();
		this._messageService.isBusy = true;

		this.getOrderItems();
		this.activeOrder.orderItems = this.orderItems;

		if (this.selectedOrderKey !== undefined && this.selectedOrderKey != null && this.selectedOrderKey.trim() != '') {
			this._invoiceService.updateOrder(this.selectedOrderKey, this.activeOrder.orderRefNumber, this.activeOrder).subscribe((response: any) => {
				this.activeOrder = response;
				this.selectedOrderKey = response.orderKey;
				this.orderRefNumber = response.orderRefNumber;
				this.showSummary();
				this._messageService.isBusy = false;
				this.getClientProcessorProfile();
				this.getClientTaxProfile();
			}, (error: any) => {
				this._messageService.showAppError('Error!', error);
			});
		} else {
			this._messageService.showAppAlert('Please Wait...', 'Sorry, things aren&apos;t ready just yet.');
		}
	}

	public showSummary() {
		this.showingInvoice = true;
		this.showingSearchResults = false;
	}

	public showResults() {
		this.showingInvoice = false;
		this.showingSearchResults = true;
	}

	private processPayResponse(data: InvoiceModel) {
		this.activeInvoice.paymentAccepted = data.paymentAccepted;
		this.activeInvoice.paidSource = data.paidSource;
		this.activeInvoice.paidAmount = data.paidAmount;
		this.processing = false;
		if (this.activeInvoice.paymentAccepted) {
			this.showingReceipt = true;
		} else {
			this.showingReceipt = false;
		}
	}

	private getAppealsUrl() {
		this._citationService.getAppealsUrl().subscribe((response: any) => {
			this.appealsUrl = response;
		}, (error: any) => {
		});
	}

	private getClientProcessorProfile() {
		this._messageService.isBusy = true;
		this.cardProcessorAvailable = null;
		var email: string = this.activeInvoice.email !== undefined && this.activeInvoice.email != null ? this.activeInvoice.email : '';
		this.getOrderItems();

		this._invoiceService.getProcessorProfile(this.totalAmountDueInclTax, this.orderRefNumber, this.selectedOrderKey, email, this.orderItems).subscribe((response: any) => {
			this.cardProcessorAvailable = response != null && response != '';
			if (this.cardProcessorAvailable) {
				this.clientPaymentProfile = response;
				if (this.clientPaymentProfile.method !== undefined && this.clientPaymentProfile.method != null && this.clientPaymentProfile.method.trim() != '') { 
					this.formSubmitMethod = this.clientPaymentProfile.method.trim();
				}
			}
			this.calcTotalAmountDue();
			this._messageService.isBusy = false;
		}, (error: any) => {
			this.cardProcessorAvailable = false;
			this._messageService.showAppError('Error!', 'Online Credit Card processing not available.');
		});
	}

	private getClientTaxProfile() {

		this._invoiceService.getClientTaxProfile(moment().format('YYYY-MM-DDTHH:mm:ss')).subscribe((response: any) => {
			this.activeTaxRates = [];
			for (var i in response) {
				var ting = this.activeTaxRates.findIndex((f: any) => { return f.name === response[i].name && moment(f.effectiveDate).isSameOrBefore(moment(response[i].effectiveDate)) });
				if (moment(response[i].effectiveDate).isSameOrBefore(moment())) {
					if (ting >= 0) {
						this.activeTaxRates.splice(ting, 1);
					}
					this.activeTaxRates.push(response[i]);
				}
			}
			this.calcTotalAmountDue();
			this._messageService.isBusy = false;
		}, (error: any) => {
			this._messageService.showAppError('Error!', error);
		});
	}

	private getOrderItems() {

		this.orderItems = [];

		for (var i in this.selectedItems) {
			if (this.selectedItems[i].amountDue > 0) {
				var orderItem: OrderItemModel = new OrderItemModel();
				orderItem.orderKey = this.selectedOrderKey;
				orderItem.entitySourceId = this._citationService.entitySourceEnum.Citation;
				orderItem.itemKey = this.selectedItems[i].citationKey;
				orderItem.itemDescription = 'Citation Number: ' + this.selectedItems[i].citationNumber + ' (' + this.selectedItems[i].description + ')';
				orderItem.itemDetail = JSON.stringify(this.selectedItems[i]);
				orderItem.quantity = 1;
				orderItem.unitPriceExclTax = this.selectedItems[i].amountDue;
				orderItem.priceExclTax = this.selectedItems[i].amountDue;
				orderItem.unitPriceInclTax = this.selectedItems[i].amountDue + this.getTaxAmount(this.selectedItems[i].amountDue);
				orderItem.priceInclTax = (this.selectedItems[i].amountDue * orderItem.quantity) + this.getTaxAmount(this.selectedItems[i].amountDue * orderItem.quantity);
				this.orderItems.push(orderItem);
			}
		}

	}

	public getNowDate() {
		var nowDate = moment().format('YYYY-MM-DDTHH:mm');
		return nowDate;
	}

	public isPaid(statusId: number) {
		return statusId == this._invoiceService.transactionStatusEnum.Paid;
	}
	public isCancelled(statusId: number) {
		return statusId == this._invoiceService.transactionStatusEnum.Cancelled || statusId == this._invoiceService.transactionStatusEnum.VelocityVerified;
	}
	public isFailed(statusId: number) {
		return statusId == this._invoiceService.transactionStatusEnum.Fail || statusId == this._invoiceService.transactionStatusEnum.Denied;
	}
	public isAccepted(statusId: number) {
		return statusId == this._invoiceService.transactionStatusEnum.Approved || statusId == this._invoiceService.transactionStatusEnum.Success;
	}
	public isPending(statusId: number) {
		return statusId == this._invoiceService.transactionStatusEnum.PendingApproval;
	}
	public isReversed(statusId: number) {
		return statusId == this._invoiceService.transactionStatusEnum.Reversed;
	}

	private getTaxAmount(amount: number) {
		var totalTaxesDue: number = 0;
		for (var i in this.activeTaxRates) {
			totalTaxesDue += amount * this.activeTaxRates[i].rate;
		}
		return totalTaxesDue;
	}

	private applyActiveTaxes(amount: number) {
		var totalTaxesDue: number = 0;
		for (var i in this.activeTaxRates) {
			this.activeTaxRates[i].amount = amount * this.activeTaxRates[i].rate;
			totalTaxesDue += this.activeTaxRates[i].amount;
		}
		return totalTaxesDue;
	}

	private backloadOrderItems() {
		this.selectedOrderKey = this.activeOrder.orderKey;
		this.orderRefNumber = this.activeOrder.orderRefNumber;
		this.invoiceMessages = this.activeOrder.messages;
		this.totalAmountDue = this.activeOrder.orderSubtotalExclTax;
		this.totalAmountDueInclTax = this.activeOrder.orderTotal;
		this.totalTaxesDue = this.activeOrder.orderTax;
		this.selectedItems = [];

		for (var i in this.activeOrder.orderItems) {
			switch (this.activeOrder.orderItems[i].entitySourceId) {
			case this._citationService.entitySourceEnum.Citation:
				var payCit: PayableCitationModel = new PayableCitationModel();
				payCit.citationKey = this.activeOrder.orderItems[i].itemKey;
				payCit.citationNumber = this.activeOrder.orderItems[i].itemDescription;
				payCit.amount = this.activeOrder.orderItems[i].priceExclTax;
				payCit.amountPaid = this.activeOrder.orderItems[i].priceInclTax;
				payCit.amountDue = this.activeOrder.orderItems[i].unitPriceExclTax;
				payCit.statusId = this.activeOrder.orderStatusId;
				payCit.statusName = this.activeOrder.orderStatusName;
				payCit.routerLink = ['/manage-citations', { key: payCit.citationKey }];
				payCit.entitySourceId = this._citationService.entitySourceEnum.Citation;

				this.selectedItems.push(payCit);
				break;
			default:
				break;
			}
		}
	}

	public popSnackBar(message: string, action: string) {
		this._snackBar.open(message, action, {
			duration: 2000,
		});
	}

	public openFramedPaymentModal() {
		const dialogRef = this.dialog.open(PaymentOptionsModal, {
			width: this.modalSize.medium,
			data: {
				payModuleTitle: (this.clientPaymentProfile?.processorName + ' Online Payment').trim(),
				solutionTypeId: this.clientPaymentProfile.solutionTypeId,
				activeInvoice: this.activeInvoice,
				orderItems: this.orderItems,
				selectedOrderKey: this.selectedOrderKey,
				orderRefNumber: this.orderRefNumber,
				totalAmountDueInclTax: this.totalAmountDueInclTax,
				clientPaymentProfile: this.clientPaymentProfile
			},
			closeOnNavigation: false,
			disableClose: true
		});
		
		dialogRef.afterClosed().subscribe(result => {
			if(result?.solutionTypeId == this.solutionTypeEnum.FullPage) {
				var queryString = '';
				for (var prop in result.responseParams) {
					queryString += '&' + prop + '=' + result.responseParams[prop];
				}
				queryString = '?email=' + this.activeInvoice.email + queryString;//.substring(1, queryString.length);
				this.router.navigateByUrl('/clearing' + queryString);
			} else if(result?.solutionTypeId == this.solutionTypeEnum.iFrame) {
				this.showingReceipt = true;
				this.activeInvoice = result.activeInvoice;
				this.processPayResponse(this.activeInvoice);
				this.router.navigate(['/pay-items', { key: this.selectedOrderKey, invNum: this.orderRefNumber, accepted: true }]);
				this.getSelectedOrder();
			}
		});
	}
}

